import { types } from "../actions";

const initialState = {
  firstName: "",
  lastName: "",
  phoneNumber: "",
  email: "",
  checkedSites: [],
  selectedGroups: {
    titles: [],
    subtitles: [],
  },
  assignedRole: "",
};

const inviteUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_FIRST_NAME:
      return {
        ...state,
        firstName: action.payload,
      };
    case types.SET_LAST_NAME:
      return {
        ...state,
        lastName: action.payload,
      };
    case types.SET_PHONE_NUMBER:
      return {
        ...state,
        phoneNumber: action.payload,
      };
    case types.SET_EMAIL:
      return {
        ...state,
        email: action.payload,
      };
    case types.UPDATE_CHECKED_SITES:
      return {
        ...state,
        checkedSites: action.payload,
      };
    case types.UPDATE_SELECTED_GROUPS:
      return {
        ...state,
        selectedGroups: action.payload,
      };
    case types.UPDATE_INVITE_USER_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case types.ASSIGN_USER_ROLE: {
      return {
        ...state,
        assignedRole: action.role,
      };
    }
    default:
      return state;
  }
};

export default inviteUserReducer;
